export interface ThoughtSpotCompanyInfo {
    ThoughtSpotEnabled?: boolean;
    ThoughtSpotEmbed?: unknown;
    SpotterEnabled?: boolean;
}

export const isThoughtSpotLiveboardEnabled = (
    companyInfo?: ThoughtSpotCompanyInfo | null
): boolean =>
    !!(companyInfo && (companyInfo.ThoughtSpotEnabled === true || companyInfo.ThoughtSpotEmbed));

export const isThoughtSpotSpotterEnabled = (
    companyInfo?: ThoughtSpotCompanyInfo | null
): boolean =>
    !!(companyInfo && companyInfo.SpotterEnabled === true);
